import { NoSsr } from "@mui/base";
import type { FunctionComponent } from "react";

import { useStoryStyleContext } from "~/components/story-style/contexts";

import { CloseButton, CloseLogo } from "./styles";

type Props = {
  className?: string;
};

export const StoryStyleCloseButton: FunctionComponent<Props> = ({ className }) => {
  const { closeRedirectUrl } = useStoryStyleContext();
  return (
    <NoSsr>
      <CloseButton className={className} pathname={closeRedirectUrl ?? ""} isAnchor>
        <CloseLogo />
      </CloseButton>
    </NoSsr>
  );
};

StoryStyleCloseButton.displayName = "StoryStyleCloseButton";
